<ng-container *ngIf="state().visible && !suppressForCommand()">
  <div class="pipeline-loader-backdrop" *ngIf="!state().minimized"></div>
  <section
    class="pipeline-loader-panel"
    [class.is-docked]="state().minimized"
    [attr.role]="state().minimized ? 'status' : 'dialog'"
    [attr.aria-modal]="state().minimized ? null : 'true'"
    aria-live="polite"
    [attr.data-status]="state().status">
    <div
      class="pipeline-loader-ring"
      [class.is-indeterminate]="state().progress === null && state().status === 'running'"
      [style.--loader-progress]="progressStyle()">
      <span *ngIf="state().status === 'running' && state().progress !== null" class="pipeline-loader-percent">
        {{ state().progress }}%
      </span>
      <span *ngIf="state().status !== 'running'" class="pipeline-loader-mark">
        {{ statusMark() }}
      </span>
    </div>

    <div class="pipeline-loader-copy">
      <p class="pipeline-loader-eyebrow">{{ statusLabel() }}</p>
      <h2>{{ state().title }}</h2>
      <p class="pipeline-loader-message">{{ state().message }}</p>
      <p *ngIf="state().detail" class="pipeline-loader-detail">{{ state().detail }}</p>
    </div>

    <div class="pipeline-loader-actions">
      <button
        *ngIf="canPause()"
        type="button"
        class="pipeline-loader-action"
        (click)="pause()">
        Pause
      </button>
      <button
        *ngIf="canResume()"
        type="button"
        class="pipeline-loader-action"
        (click)="resume()">
        Resume
      </button>
      <button
        *ngIf="canCancel()"
        type="button"
        class="pipeline-loader-action danger"
        (click)="cancel()">
        Cancel
      </button>
      <button
        type="button"
        class="pipeline-loader-action"
        (click)="toggleDock()">
        {{ state().minimized ? 'Open' : 'Dock' }}
      </button>
      <button
        *ngIf="state().canClose"
        type="button"
        class="pipeline-loader-action"
        (click)="close()">
        Close
      </button>
    </div>
  </section>
</ng-container>
